import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchReviews } from '../services/api'; // Use your API file

export const getReviews = createAsyncThunk('reviews/getReviews', async (reviewId = null) => {
    const response = await fetchReviews(reviewId); // Pass reviewId if available
    return response.data;
});

const reviewSlice = createSlice({
    name: 'reviews',
    initialState: {
        reviews: [],  // Storing open calls here
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: {
        [getReviews.pending]: (state) => {
            state.status = 'loading';
        },
        [getReviews.fulfilled]: (state, action) => {
            state.reviews = action.payload.data;
            state.status = 'succeeded';
        },
        [getReviews.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
    },
});

export default reviewSlice.reducer;